module.exports = __webpack_public_path__ + "static/simsum-mp-dj-21b4f3c879156c9ea00f54e8f22302a8.jpg";